<template>
    <div
        id="vrm-modal-notification"
        class="vrm-modal vrm-modal--alert mfp-with-anim vrm-modal-notification"
    >
        <div v-if="firstNotification" class="vrm-modal__content">
            <div class="vrm-modal__title" :class="noteClass(firstNotification)">
                <div
                    v-if="iconClass(firstNotification)"
                    class="vrm-modal__title-icon sg-vrm-icon_012_alarm-32px"
                />
                {{ noteTitle(firstNotification) }}
            </div>
            <p>
                <span v-html="firstNotification.message"></span>
            </p>
            <div class="vrm-modal__main-button">
                <button class="sg-element sg-btn sg-site" @click="closeModal">
                    {{ $t('common.ok', { i18nFallback: 'OK' }) }}
                </button>
            </div>
        </div>
        <modal-close-handle />
    </div>
</template>

<script>
import { AngularDirective } from '@/vue/decorators/angular-interop';
import { AngularLocaleBundle } from '../../../angular-bridge/modules/i18n';
import ModalCloseHandle from '@/vue/components/modals/ModalCloseHandle';
import { Vue, Component } from 'vue-property-decorator';
import {
    NOTIFICATION_TYPE_DANGER,
    NOTIFICATION_TYPE_ERROR,
    NOTIFICATION_TYPE_WARNING,
    NOTIFICATIONS,
} from '../../store/modules/notifications';

@Component({
    components: {
        ModalCloseHandle,
    },
})
@AngularDirective('vrm-notifications-modal')
@AngularLocaleBundle('core')
@AngularLocaleBundle('common')
export default class VrmNotificationModal extends Vue {
    get firstNotification() {
        const notification = this.$store.getters[NOTIFICATIONS.GET_FIRST];

        return notification;
    }

    /**
     * @param {VrmNotification} notification
     * @returns {string}
     */
    noteTitle(notification) {
        return notification.title.length
            ? notification.title
            : this.$t(`common.${notification.type}`);
    }

    /**
     * @param {VrmNotification} notification
     * @returns {string}
     */
    noteClass(notification) {
        return `vrm-modal-notification__${notification.type}`;
    }

    iconClass(notification) {
        return (
            notification.type === NOTIFICATION_TYPE_ERROR ||
            notification.type === NOTIFICATION_TYPE_DANGER ||
            notification.type === NOTIFICATION_TYPE_WARNING
        );
    }

    closeModal() {
        //Do not change to this.$emit('close'), since this will break queued notifications
        $.magnificPopup.close();
    }
}
</script>

<style scoped></style>
